import * as React from 'react';
import { ArticleHeading4, Button } from '@cian/ui-kit';
import { IPhoneButtonProps } from '../types';
import * as styles from './PhoneButtonMobile.css';
import { InteractiveElementsWrapper } from '../../InteractiveElementsWrapper';

export const PhoneButtonMobile: React.FC<IPhoneButtonProps> = ({ phone, collapsedPhone, phoneVisible, onClick }) => {
  return (
    <InteractiveElementsWrapper>
      <div className={styles['container']}>
        {phoneVisible ? (
          <ArticleHeading4 data-name="BuilderPhone">{phone}</ArticleHeading4>
        ) : (
          <Button data-name="BuilderPhoneButton" size="M" theme="fill_primary" fullWidth onClick={onClick}>
            {collapsedPhone}
          </Button>
        )}
      </div>
    </InteractiveElementsWrapper>
  );
};
